import type { ReactElement } from 'react';
import React, { useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import TooltipItem from 'atom-components/tooltip-item';
import {
  friendlyMarkStatus,
  getMarkStatusIcon,
  isMarkFinished
} from 'helpers/domain-specific/mark-status.helpers';
import { type MarkStatus } from 'services/assist-api/entities/test-instance-response-mark/types';

/**
 * Get classnames to style the mark status, excluding what is defined in the SCSS module.
 */
export const getMarkStatusBootstrapClassNames = (status: MarkStatus): string =>
  isMarkFinished(status) ? 'bg-danger text-dark' : 'bg-success text-light';

export default function MarkStatusWarningBadge({
  children
}: {
  children: MarkStatus;
}): ReactElement {
  const tooltip = useMemo(() => {
    const isTheMarkFinished = isMarkFinished(children);
    return (
      `Mark has ${isTheMarkFinished ? 'a finished' : 'an unfinished'} status which ` +
      `${isTheMarkFinished ? 'is preventing' : "isn't preventing"} the response from being force ` +
      `reallocated. ${isTheMarkFinished ? 'Reallocation requires a draft mark status.' : ''}`
    );
  }, [children]);

  return (
    <TooltipItem tooltip={tooltip}>
      <span
        className={clsx(
          'badge rounded-pill mark-status-badge',
          getMarkStatusBootstrapClassNames(children) // CSS classes from Bootstrap
        )}
      >
        <span className="me-2">{friendlyMarkStatus(children)}</span>
        <FontAwesomeIcon icon={getMarkStatusIcon(children)} size="lg" />
      </span>
    </TooltipItem>
  );
}
